import { createFileRoute } from '@tanstack/react-router'
import ClassroomTablePage from '@/pages/ClassroomsPage'

export const Route = createFileRoute('/$leaid/_error-wrapper/records/classroom/')({
  component: ClassroomTablePage,
})